<template>
  <div class="wjNewsList">
    <el-card>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_wj_addNews')}}</el-button>
      <el-table :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" v-if="proprietorNotificationListbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="title" :label="$t('lang.lbl_wj_newsTitle')">
        </el-table-column>
        <el-table-column prop="type" label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 1">疫情</span>
            <span v-if="scope.row.type == 2">本地资讯</span>
            <span v-if="scope.row.type == 3">国内要闻</span>
            <span v-if="scope.row.type == 99">首页轮播</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('lang.lbl_wj_newsDate')" sortable>
          <template slot-scope="scope">
            {{ scope.row.createTime | time }}
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <el-input v-model='taggdName' placeholder="请输入鹰眼名称" maxlength="16" show-word-limit></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTaggd">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="确定删除" :visible.sync="dialogVisibleDel" width="30%">
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleDel = false">取 消</el-button>
        <el-button type="primary" @click="delTaggd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:wjNewsList
   *@Description:万洁公司新闻
   *@author:宋莎
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  // import { mapGetters } from 'vuex'
  // import Taggd from 'taggd-manager'
  export default {
    name: '/manage/main.wjNewsList',
    data() {
      return {
        taggdList: [],
        taggd: '',
        position: '',
        taggdName: '',
        taggdDel: '',
        tagDel: '',
        dialogVisible: false,
        dialogVisibleDel: false,
        multipleSelection: [], // 多选框
        gardenId: this.$store.getters.gardenId, // 小区绑定值
        tableData: [], // 新闻list
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        proprietorNotificationListbox: require('@/config/enum').proprietorNotificationListbox // 是否隐藏复选框
      }
    },
    created() {
      setTimeout(() => {
        window.localStorage.setItem('wjNewsform', '')
      }, 200)
      this.getData()
    },
    activated() {
      this.getData()
    },
    methods: {
      // 公司新闻-获取列表数据
      getData() {
        let loading = this.$loading()
        this.$get(`/wjNews?gardenId=${this.gardenId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 新增新闻
      add() {
        window.localStorage.setItem('wjNewsform', '')
        this.$router.push({
          name: 'wjNewsEdit',
          query: {
            flag: false
          }
        })
      },
      // 编辑新闻
      edit(rowData) {
        window.localStorage.setItem('wjNewsform', '')
        this.$router.push({
          name: 'wjNewsEdit',
          query: {
            flag: true,
            object: rowData
          }
        })
      },
      // 删除新闻
      deleteOne(id) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }).then(() => {
            this.$delete(`/wjNews/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 更新
      commit() {
        this.pageNo = 1
        this.getData()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      // 添加鹰眼
      addTaggd() {
        var that = this
        console.log(that.position)
        var tag = new Taggd.Tag(that.position, that.taggdName).disableEditorMode()
          that.taggdList.push(tag)
          that.taggd.addTag(tag)
          that.dialogVisible = false
          that.position = ''
          that.taggdName = ''
          console.log(that.taggdList)
      },
      // 删除鹰眼
      delTaggd() {
        let that = this
        let index
          for (let i = 0; i < that.taggdList.length; i++) {
            index = that.taggdList.findIndex(function (val) {
              if (val.position.x == that.tagDel.position.x && val.position.y == that.tagDel.position.y) {
                return i
              }
            })
          }
          if (that.taggdList.length > 1) {
            that.taggdDel.deleteTag(index)
            that.taggdList.splice(index, 1)
          } else {
            that.taggdDel.deleteTags()
            that.taggdList = []
          }
          that.dialogVisibleDel = false
          that.taggdDel = ''
          that.tagDel = ''
      }
    },
    mounted() {
      var image
      var taggd
      var that = this
      setTimeout(function () {
        image = document.getElementById('image')
        that.taggdList = [
          new Taggd.Tag({
            x: 200,
            y: 200
          }, '点位名称').enableEditorMode(),
          new Taggd.Tag({
            x: 600,
            y: 300
          }, '点位名称').enableEditorMode(),
          new Taggd.Tag({
            x: 300,
            y: 400
          }, '点位名称').enableEditorMode(),
          new Taggd.Tag({
            x: 400,
            y: 300
          }, '点位名称1').disableEditorMode()
        ]
        taggd = new Taggd(image, {}, that.taggdList).enableEditorMode()
        console.log(taggd)
        taggd.on('taggd.editor.add', function (taggd, position) {
          that.dialogVisible = true
          that.taggd = taggd
          that.position = position
        })
        taggd.on('taggd.tag.click', function (taggd, tag) {
          that.dialogVisibleDel = true
          that.taggdDel = taggd
          that.tagDel = tag
          // let index
          // for (let i = 0; i < that.taggdList.length; i++) {
          //   index = that.taggdList.findIndex(function (val) {
          //     console.log(val)
          //     if (val.position.x == tag.position.x && val.position.y == tag.position.y) {
          //       return i
          //     }
          //   })
          // }
          // if (that.taggdList.length > 1) {
          //   taggd.deleteTag(index)
          //   that.taggdList.splice(index, 1)
          // } else {
          //   taggd.deleteTags()
          //   that.taggdList = []
          // }
        })
      }, 100)
    },
  }
</script>

<style>
  /* @import '../../../style/taggd.css';
  @import '../../../style/layout.css';
  @import '../../../style/taggd-classic.css'; */
</style>